
    import "src/app/AppAdmin/Billing/Payments/index.module.scss?farm_css_modules";
    
    export default {"paymentStatusFilter": `paymentStatusFilter-04521706`}
    